module.exports = __webpack_public_path__ + "static/media/afi.294f0444.png";